module.exports = __webpack_public_path__ + "img/tc_1.20804f56.png";